<script>
  import { onMount } from 'svelte';
  import { Link } from "svelte-routing";
  import { Card, CardBody, Col, Container, Row } from "sveltestrap";
  import LanguageDropdown from "../../common/LanguageDropdown.svelte";
  

  let data = '';
  async function getData(){
		let location = 'es-CL'
		location = await localStorage.getItem('LANGUAGE');
		if( location=="es"){
			location='es-CL';
		}
		var requestOptions = {
		method: 'GET',
		redirect: 'follow'
		};
		fetch(`https://api.rastros.cl/api/recovery-pass-confirmation-page?populate=%2A&locale=${location}`, requestOptions)
		.then(response => response.json())
		.then(result => {
			data = result.data;
		})
		.catch(error => console.log('error al contactar al servicio: ', error));
	}

  onMount(async () => {
		await getData();
  	});

</script>

<div class="account-pages my-5 pt-sm-5">
  <Container>
    
    <Row class="justify-content-center">
      <Col md={8} lg={6} xl={5}>
        <Card>
          <LanguageDropdown  on:chageLang={getData}/>
          <CardBody>
            <div class="p-2">
              <div class="text-center">
                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bxs-envelope h1 mb-0 text-primary" />
                  </div>
                </div>
        
                <div class="p-2 mt-4">
                  <h4>{data.title}</h4>
                  <p>
                    {data.principalMessage}
                    <span class="fw-semibold"> {localStorage.getItem('emailRecovery')}</span>, {data.secondaryMessage}
                  </p>
                  <div class="mt-4">
                    <a href={data.linkLogin} class="btn btn-success w-md"> {data.buttonLogin} </a>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
        <div class="mt-5 text-center">
          <p>
            {data.tryAgain}
            <Link to="/auth-recoverpw" class="fw-medium text-primary">
             {data.resendLabel}
            </Link>
          </p>
          <p>
            © {new Date().getFullYear()} {data.copyright}
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</div>